document.querySelectorAll('[data-rg-apex]').forEach(root => {
  const inputs = [...root.querySelectorAll('[data-size]')];
  const count = root.querySelector('[data-total]');
  const estimate = root.querySelector('[data-estimate]');
  const error = root.querySelector('[data-error]');
  const price = Number(root.dataset.price);
  const roster = window.RGPlayerRoster(root, inputs);
  const field = name => root.querySelector('[data-' + name + ']').value.trim();
  function totals() {
    const rows = inputs.map(el => ({size:el.dataset.size,id:Number(el.dataset.variant),quantity:Math.max(0,parseInt(el.value,10)||0)}));
    const total = rows.reduce((sum,row) => sum + row.quantity, 0);
    count.textContent = total + ' ' + (total === 1 ? 'set' : 'sets');
    estimate.textContent = total ? 'Estimated kit total: $' + (total * price).toFixed(2) + ' AUD' : 'Starting total for 10 sets: $' + (10 * price).toFixed(2) + ' AUD';
    if (total >= 10) error.hidden = true;
    return {rows,total};
  }
  inputs.forEach(el => el.addEventListener('input', totals));
  function valid() {
    if (inputs.some(input => input.value !== '' && (!Number.isInteger(Number(input.value)) || Number(input.value) < 0 || Number(input.value) > 999))) {
      error.textContent = 'Please enter whole numbers from 0 to 999 for each size.';
      error.hidden = false;
      return null;
    }
    const choice = totals();
    if (choice.total < 10) {
      error.textContent = 'Please select at least 10 sets across your team.';
      error.hidden = false;
      root.querySelector('.rg-apex__builder').scrollIntoView({behavior:'smooth',block:'center'});
      inputs[0].focus();
      return null;
    }
    return choice;
  }
  root.querySelectorAll('[data-whatsapp]').forEach(button => button.addEventListener('click', () => {
    const choice = valid(); if (!choice) return;
    const sizes = choice.rows.filter(row => row.quantity).map(row => row.size + ': ' + row.quantity).join(', ');
    const lines = ['Hi RG Sports, I would like a quote and free mock-up for ' + root.dataset.title,
      'Product: ' + root.dataset.url, 'Team: ' + (field('team') || 'To confirm'),
      'Sizes: ' + sizes + ' (' + choice.total + ' sets)',
      'Design/colours: ' + (field('notes') || 'To discuss'),
      'Players:', ...roster.lines(), 'Please confirm the final price and dispatch timing before payment.'];
    window.open('https://wa.me/61405632724?text=' + encodeURIComponent(lines.join('\n')), '_blank', 'noopener');
  }));
  const checkout = root.querySelector('[data-apex-checkout]');
  checkout?.addEventListener('click', async () => {
    const choice = valid(); if (!choice) return;
    checkout.disabled = true; checkout.textContent = 'Adding your kits…';
    const properties = {'Team or club':field('team') || 'To confirm', 'Design notes':field('notes') || 'To discuss', 'Artwork approval':'Required before production'};
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:choice.rows.filter(row => row.quantity).map(row => ({
          id:row.id, quantity:row.quantity, properties:{...properties,...roster.propertiesForSize(row.size)}
        }))})
      });
      if (!response.ok) { const result = await response.json(); throw new Error(result.description || result.message || 'Could not add these kits'); }
      window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
    } catch (e) {
      error.textContent = e.message || 'Could not start checkout. Try WhatsApp instead.';
      error.hidden = false; checkout.disabled = false; checkout.textContent = 'Buy securely through checkout →';
    }
  });
  totals();
});
